(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .directive('panelAction', actionElem);

    function actionElem() {
        return {
            restrict: 'A',
            scope: {
                event:'=?',
                triggeredWhen: '=?',
            },
            link: function(scope, elem) {
                elem.on('click', function() {
                    if (scope.event && scope.event.length > 0) {
                        if (typeof scope.triggeredWhen !== typeof undefined) {
                            scope.triggeredWhen && scope.$emit(scope.event);
                        } else {
                            scope.$emit(scope.event);
                        }
                    }
                });
                scope.$on('$destroy', function() {
                    elem.off();
                });
            }
        };
    }
})();